<template>
  <RygenButton
    class="add-button"
    mode="tertiary"
    icon="pi pi-plus"
    icon-pos="left"
    :label="t('common.addParam', { param: label })"
    :disabled="disabled"
    @click="emit('click', $event)"
  />
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';

const props = defineProps({
  label: {
    type: String,
    required: false,
    default: () => '',
  },
  disabled: {
    type: Boolean,
    required: false,
    default: () => false,
  },
});
const { label, disabled } = toRefs(props);
const emit = defineEmits<{
  (event: 'click', payload: MouseEvent): void;
}>();

const { t } = useI18n();
</script>
